import styled from 'styled-components';

export const InvoiceLinesSubtitle = styled.h3`
  margin-top: 16px;
  font-weight: 600;
`;
